/* eslint-disable no-unused-vars */
var ADN_ENV_KEY = 'dev';